import CTASection from '../components/CTASection/CTASection';
import { featureCategories, features } from '../data/features';
import { stockAssets } from '../config/stockAssets';
import { usePageTitle } from '../hooks/usePageTitle';
import styles from './FeaturesPage.module.css';

function FeaturesPage() {
  usePageTitle('Features');

  return (
    <>
      <section className={styles.hero}>
        <div className={`container ${styles.heroGrid}`}>
          <div>
            <span className="sectionLabel">Features</span>
            <h1 className={styles.title}>Everything your venue team needs on game day</h1>
            <p className={styles.lead}>
              ONI is a stadium-native platform designed for operators — with a fan experience that keeps guests in their seats
              and drives more concession revenue per event.
            </p>
          </div>
          <img
            src={stockAssets.featuresOrder}
            alt="A fan holding a phone showing the ONI checkout with itemized food and order total"
            className={styles.heroImage}
            loading="eager"
          />
        </div>
      </section>

      {featureCategories.map((category) => {
        const categoryFeatures = features.filter((f) => f.category === category.id);
        return (
          <section key={category.id} className={`section ${styles.section}`}>
            <div className="container">
              <span className="sectionLabel">{category.label}</span>
              <h2 className="sectionTitle">{category.subtitle}</h2>

              <div className={styles.featureList}>
                {categoryFeatures.map((feature) => (
                  <article key={feature.title} className={styles.featureBlock}>
                    <span className={styles.icon} aria-hidden="true">{feature.icon}</span>
                    <div>
                      <h3 className={styles.featureTitle}>{feature.title}</h3>
                      <p className={styles.details}>{feature.details}</p>
                      <ul className={styles.points}>
                        {feature.points.map((point) => (
                          <li key={point}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        );
      })}

      <CTASection />
    </>
  );
}

export default FeaturesPage;
